import { useState } from 'react';
import { Button } from '../ui/button';
import { Textarea } from '../ui/textarea';
import { Copy, RefreshCw, ArrowRightLeft } from 'lucide-react';
import { toast } from 'sonner';

const TextToBinaryTool = () => {
  const [input, setInput] = useState('');
  const [mode, setMode] = useState('encode');

  const textToBinary = (text) => {
    return text.split('').map(char => 
      char.charCodeAt(0).toString(2).padStart(8, '0')
    ).join(' ');
  };

  const binaryToText = (binary) => {
    try {
      const bytes = binary.trim().split(/\s+/);
      return bytes.map(byte => 
        String.fromCharCode(parseInt(byte, 2))
      ).join('');
    } catch {
      return 'Invalid binary input';
    }
  };

  const output = mode === 'encode' ? textToBinary(input) : binaryToText(input);

  const copyOutput = () => {
    navigator.clipboard.writeText(output);
    toast.success('Copied!');
  };

  return (
    <div className="space-y-6" data-testid="text-binary-tool">
      <div className="flex gap-2">
        <Button
          variant={mode === 'encode' ? 'default' : 'outline'}
          onClick={() => { setMode('encode'); setInput(''); }}
        >
          Text → Binary
        </Button>
        <Button
          variant={mode === 'decode' ? 'default' : 'outline'}
          onClick={() => { setMode('decode'); setInput(''); }}
        >
          Binary → Text
        </Button>
      </div>

      <div className="grid md:grid-cols-2 gap-4">
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">
            {mode === 'encode' ? 'Text Input' : 'Binary Input'}
          </label>
          <Textarea
            placeholder={mode === 'encode' ? 'Enter text to convert to binary...' : 'Enter binary (space-separated bytes)...'}
            value={input}
            onChange={(e) => setInput(e.target.value)}
            className="min-h-[200px] font-mono text-sm bg-muted/50"
          />
        </div>
        <div>
          <label className="text-sm text-muted-foreground mb-2 block">
            {mode === 'encode' ? 'Binary Output' : 'Text Output'}
          </label>
          <Textarea
            value={output}
            readOnly
            className="min-h-[200px] font-mono text-sm bg-muted/50"
          />
        </div>
      </div>

      <div className="flex gap-2">
        <Button onClick={copyOutput} disabled={!output}>
          <Copy className="w-4 h-4 mr-2" /> Copy Result
        </Button>
        <Button onClick={() => { setInput(output); setMode(mode === 'encode' ? 'decode' : 'encode'); }} variant="outline" disabled={!output}>
          <ArrowRightLeft className="w-4 h-4 mr-2" /> Swap
        </Button>
        <Button onClick={() => setInput('')} variant="outline">
          <RefreshCw className="w-4 h-4 mr-2" /> Clear
        </Button>
      </div>
    </div>
  );
};

export default TextToBinaryTool;
